<template>
  <div>
    <CrudList
      title="Profesionales"
      storeName="User_professionals"
      parentStoreName="Professionals"
      parentUrlKey="user_id"
      :canAdd="false"
      :canEdit="false"
      :canDelete="false"
      :canSearch="false"
    >
      <template v-slot:profile_picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.profile_picture">
              <img
                :src="item.profile_picture"
                alt=""
                style="object-fit: cover"
              />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>

      <template v-slot:speciality="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <div v-if="Array.isArray(item.speciality_id)" :key="item">
              <div
                v-for="(speciality, index) in item.speciality_id"
                :key="index"
              >
                {{ speciality.name }}
              </div>
            </div>
            <div v-else>
              {{ item.speciality_id.name }}
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-slot:credits="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-btn
              color="primary"
              small
              :loading="loadingSave"
              :disabled="loadingSave"
              @click="addOneCredit(item)"
            >
              {{ item.credits }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </CrudList>
    <v-dialog v-model="showConfirmDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Confirmar acción</v-card-title>
        <v-card-text>
          ¿Estás seguro que querés agregar <strong>1 crédito</strong> a
          <strong
            >{{ pendingCreditItem?.first_name }}
            {{ pendingCreditItem?.last_name }}</strong
          >
          con la especialidad
          <strong>{{ pendingCreditItem?.speciality_id[0]?.name }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="showConfirmDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text @click="addOneCreditConfirmed">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CrudList from '@/components/Crud/CrudList';

export default {
  components: { CrudList },
  data() {
    return {
      showEditCredits: false,
      loadingSave: false,
      showConfirmDialog: false,
      pendingCreditItem: null,
    };
  },
  methods: {
    async addOneCredit(item) {
      this.pendingCreditItem = item;
      this.showConfirmDialog = true;
    },

    async addOneCreditConfirmed() {
      this.showConfirmDialog = false;
      const item = this.pendingCreditItem;
      this.pendingCreditItem = null;

      try {
        this.loadingSave = true;
        const userId = this.$route.params.user_id;
        const professionalId = item.id || item._id;
        const specialityId =
          item.speciality_id && item.speciality_id.length > 0
            ? item.speciality_id[0]._id
            : null;

        if (!specialityId) {
          this.$toast.error('No se pudo encontrar la especialidad', {
            position: 'top-right',
          });
          return;
        }

        await this.$store.dispatch('User_professionals/updateCredits', {
          userId,
          professionalId,
          specialityId,
        });

        this.$toast.success('Crédito agregado correctamente!', {
          position: 'top-right',
        });

        await this.$store.dispatch('User_professionals/getList', {
          ...this.$store.state.User_professionals.options,
          user_id: this.$route.params.user_id,
        });
      } catch (error) {
        this.$toast.error('Error al agregar crédito', {
          position: 'top-right',
        });
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>
